const sectionCode = "SPRO2";
const chartCode = "C036x";

import { Procedures } from "modules/provider/shared/procedure-charts";

function T36Procedures() {
  return <Procedures chartCode={chartCode} sectionCode={sectionCode} />;
}

export { T36Procedures };
